module.exports = __webpack_public_path__ + "static/media/mediterranean.60dc5638.png";